import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

import jsQR from "jsqr";

const UPIDisclaimer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [qrCodeData, setQrCodeData] = useState(null);
  const [paymentQrCodeError, setPaymentQrCodeError] = useState("");


  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0, image.width, image.height);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const qrCode = jsQR(
            imageData.data,
            imageData.width,
            imageData.height
          );

          if (qrCode) {
            const queryString = qrCode.data.split("?")[1]; // Get the part after '?'
            if (!queryString) {
                setPaymentQrCodeError(
                  "Invalid Upi Qr Code Please Go Back And Come Again"
                );
              return;
            }

            // Manually parse query parameters
            const params = {};
            queryString.split("&").forEach((param) => {
              const [key, value] = param.split("=");
              params[key] = decodeURIComponent(value || "");
            });

            const upiData = {
              upiId: params.pa || "",
              upiUserName: params.pn || "",
            };

            navigate("/StoreManagementCreate", {
              state: {
                id: id,
                upiData: upiData,
              },
            });
            // setQrCodeData(qrCode.data);
          } else {
            setPaymentQrCodeError(
                "No Qr Code Found In Image Or Qr Code Image is Clear"
              );
            // alert("No QR Code found in image");
          }
        };
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreManagementCreate", {
                      state: {
                        id: id,
                        upiData: null,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                UPI ID Disclaimer
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="mx-4">
          <div
            className="flex-1 shadow-2 p-2 border-2 border-round-xl cursor-pointer"
            style={{ borderColor: "#fff", backgroundColor: "#fff" }}
          >
            <p className="text-3xl font-bold text-justify">
              Disclaimer for UPI ID Storage & Liability
            </p>
            <p className="text-lg font-normal text-justify my-4">
              Dhobi Cart collects and stores UPI IDs solely for facilitating
              transactions. However, we do not guarantee the accuracy, security,
              or uninterrupted availability of UPI-based transactions.
            </p>
            <p className="text-lg font-normal text-justify my-4">
              The UPI ID entered in the application is solely the responsibility
              of the admin of the brand, and Dhobi Cart is not responsible for
              any transactions made through the QR code generated using the
              provided UPI ID. Any loss, unauthorized access, misuse, fraud, or
              disputes related to transactions must be addressed directly with
              the respective bank or payment service provider.
            </p>
            <p className="text-lg font-normal text-justify my-4">
              Dhobi Cart does not store sensitive financial details such as
              OTPs, PINs, or passwords. Users are responsible for ensuring the
              security of their payment credentials and transactions.
            </p>
          </div>
{/* 
          <div
            className="flex-1 shadow-2 p-2 my-3 border-2 border-round-xl cursor-pointer"
            style={{ borderColor: "#fff", backgroundColor: "#fff" }}
          >
            <h2>Upload Your Payment QrCode Image Below</h2>
            <input type="file" accept="image/*" onChange={handleImageUpload} />
            {paymentQrCodeError && <p className="text-xl font-normal" style={{color:"red"}}>{paymentQrCodeError}</p>}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default UPIDisclaimer;
